var map = {
	"./env.development": "./src/config/env.development.js",
	"./env.development.js": "./src/config/env.development.js",
	"./env.production": "./src/config/env.production.js",
	"./env.production.js": "./src/config/env.production.js",
	"./env.staging": "./src/config/env.staging.js",
	"./env.staging.js": "./src/config/env.staging.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/env\\..*$";